import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function ProductCard({ product, index = 0 }) {
  const p = product;
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.55, delay: (index % 4) * 0.07, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link
        to={`/products/${p.id}`}
        data-testid={`product-card-${p.id}`}
        className="group block bg-white border border-zinc-200 hover:border-signal hover:-translate-y-1 hover:shadow-[0_16px_40px_-16px_rgba(22,48,29,0.25)] transition-all duration-300 h-full"
      >
        <div className={`relative h-52 flex items-center justify-center overflow-hidden ${p.darkImage ? "spotlight-dark" : "spotlight"}`}>
          <img
            src={p.image}
            alt={`${p.name} — order ${p.orderNumber}`}
            loading="lazy"
            className="max-h-40 w-auto object-contain transition-transform duration-500 group-hover:scale-[1.05]"
          />
          <span className="absolute top-3 left-3 font-mono text-[10px] uppercase tracking-widest text-zinc-500 bg-white/80 px-2 py-0.5">
            {p.category}
          </span>
        </div>
        <div className="p-5">
          <div className="flex items-start justify-between gap-3">
            <h3 className="font-display text-lg font-bold text-ink leading-snug">{p.name}</h3>
            <ArrowUpRight size={18} className="text-zinc-400 group-hover:text-signal transition-colors shrink-0 mt-1" />
          </div>
          <p className="font-mono text-xs text-signal mt-1.5">Order № {p.orderNumber}</p>
          <p className="text-sm text-zinc-500 mt-2.5 leading-relaxed line-clamp-2">{p.tagline}</p>
          <div className="flex flex-wrap gap-1.5 mt-4">
            {p.sensor && <span className="text-[11px] px-2 py-0.5 bg-bone border border-zinc-200 text-zinc-600">{p.sensor}</span>}
            {p.applications.slice(0, 2).map((a) => (
              <span key={a} className="text-[11px] px-2 py-0.5 bg-bone border border-zinc-200 text-zinc-600">{a}</span>
            ))}
            <span className="text-[11px] px-2 py-0.5 bg-bone border border-zinc-200 text-zinc-600">{p.power}</span>
          </div>
          <div className="mt-4 pt-3 border-t border-zinc-100 flex items-center justify-between">
            <span className="font-mono text-[11px] text-zinc-500">
              {p.specs["Input Voltage"]} · {p.specs["IP Rating"]}
            </span>
            <span className="text-xs font-medium text-ink group-hover:text-signal transition-colors">View Product</span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
